import Icon, { IconProps } from './Icon';

import HomeIcon from '../../../assets/icons/home-05.svg?react';

const Home: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <HomeIcon />
    </Icon>
  );
};

export default Home;
